module.exports = __webpack_public_path__ + "img/loading.77d6a12e.gif";